import type { HomePageKey, HomePageVariant } from '@/interface/home-pages';

import { HOME_PAGES_V1 } from './home-v1';
import { HOME_PAGES_V2 } from './home-v2';
import { HOME_PAGES_V3 } from './home-v3';
import { HOME_PAGES_V4 } from './home-v4';

// O registry é a única lista de variantes da Home. home-v1 é a Home do staging sem versão (`/br/pt`);
// home-v2..v4 são as `v2`..`v4` de `versoes.json` do pacote, com o mesmo cta/visual.
export const HOME_PAGES: Record<HomePageKey, HomePageVariant> = {
  [HOME_PAGES_V1.key]: HOME_PAGES_V1,
  [HOME_PAGES_V2.key]: HOME_PAGES_V2,
  [HOME_PAGES_V3.key]: HOME_PAGES_V3,
  [HOME_PAGES_V4.key]: HOME_PAGES_V4,
};

// Para onde cai toda chave que o registry não conhece (e a única servida enquanto não houver round robin).
export const HOME_PAGE_DEFAULT_KEY: HomePageKey = HOME_PAGES_V1.key;

export const KNOWN_HOME_PAGE_KEYS: ReadonlySet<string> = new Set(Object.keys(HOME_PAGES));

export const isHomePageKey = (value: unknown): value is HomePageKey => typeof value === 'string' && KNOWN_HOME_PAGE_KEYS.has(value);
